import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"
import { Link, Asset } from "../../../../plugins/gatsby-plugin-atollon"

const CtaExpertise = ({ title, richContent, image, button }) => {

  return (
    <section className="cta-expertise">
      <div className="cta-expertise__asset">
        {image && <Asset asset={image} />}
      </div>
      <div className="cta-expertise__inner">
        <div className="cta-expertise__content">
          {richContent && <StructuredText data={richContent} />}
          {button?.length > 0 && (
            <Link
              className="btn btn--orange"
              to={button[0].link[0].externalLink ? button[0].link[0].externalLink : button[0].link[0].internalLink.permalink}
            >
              {button[0].title}
            </Link>)}
        </div>

        <div className="cta-expertise__title">
          {title && <h2>{parse(title)}</h2>}
        </div>
      </div>
    </section>
  )
}
export default CtaExpertise

export const query = graphql`
fragment CtaExpertiseProps on DatoCmsCtaExpertise {
  ... on DatoCmsCtaExpertise {
    id
    richContent {
      value
    }
    image {
      ...InternalAssetProps
    }
    button {
      ...LinkWithTitleProps
    }
    title
  }
}
`